// Bulk-action panel shown in the Web Categories toolbar while rows are
// selected. Mirrors the 2026.05.27 categories mockup `.bulk-actions` bar.

import type React from 'react'
import { F, p } from './rowParts'

const bulkBtnStyle: React.CSSProperties = {
  padding: '5px 10px',
  fontSize: 12,
  fontWeight: 500,
  borderRadius: 6,
  border: `1px solid ${p.gray[300]}`,
  background: p.white,
  color: p.gray[600],
  cursor: 'pointer',
  fontFamily: F,
}

const bulkDangerBtnStyle: React.CSSProperties = {
  ...bulkBtnStyle,
  border: `1px solid ${p.red[200]}`,
  color: p.red[700],
}

interface WebCategoriesBulkPanelProps {
  selectedCount: number
  onBulkShow: () => void
  onBulkHide: () => void
  onBulkDelete: () => void
  onClearSelection: () => void
}

export const WebCategoriesBulkPanel: React.FC<WebCategoriesBulkPanelProps> = ({
  selectedCount,
  onBulkShow,
  onBulkHide,
  onBulkDelete,
  onClearSelection,
}) => (
  <div
    data-testid="category-bulk-actions"
    style={{
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '6px 12px',
      borderRadius: 6,
      background: p.brand.light,
    }}
  >
    <span
      style={{
        fontSize: 12.5,
        fontWeight: 600,
        color: p.brand.primary,
      }}
    >
      {selectedCount} selected
    </span>
    <button type="button" onClick={onBulkShow} style={bulkBtnStyle}>
      Show
    </button>
    <button type="button" onClick={onBulkHide} style={bulkBtnStyle}>
      Hide
    </button>
    <button type="button" onClick={onBulkDelete} style={bulkDangerBtnStyle}>
      Delete
    </button>
    <button
      type="button"
      onClick={onClearSelection}
      aria-label="Clear selection"
      title="Clear selection"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        border: 'none',
        background: 'transparent',
        color: p.gray[500],
        cursor: 'pointer',
        fontSize: 15,
        lineHeight: 1,
      }}
    >
      ✕
    </button>
  </div>
)
